import { useState } from 'react';

////import { Icon } from '../../components/icon/Icon';

import { PrimaryButton } from '../../components/button/PrimaryButton';
import { SecondaryButton } from '../../components/button/SecondaryButton';
import { Modal } from '../../components/Modal';
import { useFetchUser } from '../../hooks/useFetchUser';
import { t } from '../../services/translation/translation';

type Props = {
  onClose: () => void;
};

export const ModalContact = ({ onClose }: Props) => {
  const { data: user } = useFetchUser();
  const [emailText, setEmailText] = useState('');
  const handleSendEmail = () => {
    const href = `mailto:serviceclient@allocab.com?subject=Message de ${user?.firstName} ${
      user?.lastName
    }&body=${encodeURIComponent(emailText)}`;

    const mail = document.createElement('a');
    mail.href = href;
    mail.target = '_blank';
    mail.click();

    mail.remove();
    /*
    window.open(
      `mailto:milan.liptak@allocab.com?subject=Message de ${user?.firstName} ${user?.lastName}&body=${encodeURIComponent(
        emailText,
      )}`,
      '_blank',
    );*/
    setEmailText('');
    onClose();
  };
  return (
    <Modal onClose={onClose}>
      {
        <div className="flex flex-col justify-center items-center">
          <h1 className="text-3xl text-center">{t('nav.contact-us')}</h1>
          <p className="text-center mt-2 mb-5">{t('nav.contact-us-detail')}</p>
          <div className="w-full relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t" />
            </div>
            <div className="relative flex justify-center text-lg">
              <span className="bg-background px-2">{t('nav.send-us-message')}</span>
            </div>
          </div>
          <div className="mt-5 flex flex-col justify-center items-center w-full">
            <div className="flex flex-col justify-center items-center w-full">
              <label htmlFor="message">{t('nav.message')}</label>
              <textarea
                value={emailText}
                onChange={e => setEmailText(e.target.value)}
                name="message"
                id="message"
                rows={10}
                className="block w-full border-0 py-1.5  shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
              />
            </div>
            <div className="flex justify-evenly items-center w-full mt-5">
              <SecondaryButton onClick={onClose} className="flex-1 m-5">
                {t('common.back')}
              </SecondaryButton>
              <PrimaryButton className="flex-1 m-5" onClick={handleSendEmail}>
                {t('nav.send')}
              </PrimaryButton>
            </div>
          </div>
        </div>
      }
    </Modal>
  );
};
